import { h, Component } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import StatusCircle from '../ui-components/StatusCircle'
import {isChangeEvent} from "../../libs/preact-entry";

interface Props {
  title: string,
  onTitleChanged: CallableFunction,
  error: string,
  hasUnsavedChanges: boolean,
  published: boolean
}

interface State {
  titleInputVisible: boolean
}

class Title extends Component<Props, State> {
  titleInputRef: HTMLElement | undefined

  constructor (props: Props) {
    super(props)
    this.state = {
      titleInputVisible: false
    }
  }

  componentDidMount () {
    document.addEventListener('mousedown', (e: MouseEvent) => this.onClickOutsideOfTitle(e))
    document.addEventListener('keypress', (e: KeyboardEvent) => this.onPressEnterInTitle(e))
  }

  onTitleClicked () {
    this.setState({ titleInputVisible: true }, () => {
      if (this.titleInputRef) {
        this.titleInputRef.focus()
      }
    })
  }

  onClickOutsideOfTitle (e: MouseEvent) {
    if (this.titleInputRef && !this.titleInputRef.contains(e.target as Node)) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  onPressEnterInTitle (e: KeyboardEvent) {
    if (this.titleInputRef && e.keyCode === 13) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  render ({ title, onTitleChanged, error, hasUnsavedChanges, published }: Props, state: State) {
    let metadata = published ? 'Published event' : 'New event'

    return (
      <div>
        {this.state.titleInputVisible
          ? <input
            class='event-creator__title qa-title-input form-control'
            type='text'
            value={title}
            required
            onChange={e => {
              if (isChangeEvent(e)) {
                onTitleChanged(e.target.value.trim())
              }
            }}
            maxLength={250}
            ref={(titleInput) => { this.titleInputRef = titleInput }}
          />
          : <div>
            <Tooltip
              trigger={
                <h2
                  class={`event-creator__title qa-title-text ${title ? '' : 'event-creator__title--empty'}`}
                  onClick={() => this.onTitleClicked()}>{title || 'Untitled'}
                </h2>}
              tooltipMessage={error ? error : title ? 'Rename' : 'Add a title'} //eslint-disable-line
              customClasses={error ? 'tooltip-show' : null}
              qaClasses='qa-title-tooltip'
            />
            <div class='event-creator__creation-status pull-left'>
              <StatusCircle variant={hasUnsavedChanges ? 'draft' : (published ? 'published' : false)} />
              <p class='event-creator__creation-status-text'>
                { metadata }
              </p>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Title
